export default __webpack_public_path__ + "static/media/card-i-icon.3b5f2913.svg";